import { localStorageInstance } from '@gem/modules/storage';

export const GUEST_CALL_CHANNEL_ID = 'guestCAllChannelId';
export const GUEST_CALL_ALLOW_GUESTS = 'guestCAllAllowGuests';
export const GUEST_CALL_INVITATION_URL = 'guestCallInvitationUrl';

export const setGuestCallChannelId = (channelId: string): void => {
  localStorageInstance.setItem(GUEST_CALL_CHANNEL_ID, channelId);
};

export const setGuestCallAllowGuests = (value: boolean): void => {
  localStorageInstance.setItem(GUEST_CALL_ALLOW_GUESTS, JSON.stringify(value));
};

export const setGuestCallInvitationUrl = (url: string | null): void => {
  if (!url) {
    localStorageInstance.removeItem(GUEST_CALL_INVITATION_URL);
    return;
  }
  localStorage.setItem(GUEST_CALL_INVITATION_URL, url);
};

export const getGuestCallChannelId = (): string | null => {
  return localStorageInstance.getItem(GUEST_CALL_CHANNEL_ID);
};

export const getGuestCallAllowGuests = (): boolean | null => {
  const value = localStorage.getItem(GUEST_CALL_ALLOW_GUESTS);

  if (!value) {
    return null;
  }

  return value === 'true';
};

export const getGuestCallsInvitationUrl = (): string | null => {
  return localStorage.getItem(GUEST_CALL_INVITATION_URL);
};
